import { ApiResponse } from "./../common/interfaces";
import apiPlugin from "./apiPlugin";

export async function GetGTLDetailPartFor(
	part: string,
	latestFeedsBatchNum?: number
): Promise<ApiResponse<any>> {
	if (part !== "Video" && part !== "Description" && part !== "LatestFeeds") {
		//part does not match an api call
		return {
			error: "Part does not match an available API call",
		};
	}

	const queryParam =
		part === "LatestFeeds" && latestFeedsBatchNum !== undefined
			? `?batchNum=${latestFeedsBatchNum}`
			: "";

	return await apiPlugin<string | string[]>(
		"GET",
		`GetGTLDetail${part}${queryParam}`
	);
}
